import React from 'react'
import { connect } from 'react-redux'
import { store } from "../store"
import { push } from "react-router-redux"
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import chartHelper from '../util/chartFormatter'
import Nav from './widgets/Nav'
import Header from './widgets/Header'

import ListErrors from './widgets/ListErrors'
import { Link } from 'react-router-dom'

import SortableTree, { addNodeUnderParent, removeNodeAtPath, changeNodeAtPath, getFlatDataFromTree, getTreeFromFlatData } from 'react-sortable-tree';
import FileExplorerTheme from 'react-sortable-tree-theme-file-explorer';
import key from 'react-key-string';
import ReactModal from 'react-modal'
import Loading from './widgets/Loading'

import {
  DIRECTORY_LIST_PAGE_LOADED
} from '../constants/actionTypes'

const DEFAULT_DIRECTORIES = [{ title: '/root', key: 'root', canDrag: false, canRemove: false }]
const mapStateToProps = state => ({
  ...state.file,
  currentUser: state.common.currentUser,
  inProgress: state.common.inProgress
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: DIRECTORY_LIST_PAGE_LOADED, payload })
  },
})

class Dashboard extends React.Component {
  constructor() {
    super()
    this.state = {
      treeData: [],
      showModal: false
    }
    this.updateState = field => ev => {
      const state = this.state;
      const newState = Object.assign({}, state, { [field]: ev.target.value });
      this.setState(newState);
    }
    this.submitForm = (name, key) => ev => {
      ev.preventDefault()

    }
  }
  getModelParent = () => {
    return document.querySelector('#main')
  }

  openModal = (item) => {
    this.setState({ showModal: true })
    Object.assign(this.state, {

    })
  }
  closeModal = () => {
    this.setState({ showModal: false })
    Object.assign(this.state, {
      name: ''
    })
  }

  handleTreeOnChange = treeData => {
    this.setState({ treeData });
  };

  componentWillMount() {
    if (!this.props.currentUser) {
      store.dispatch(push("/login"))
    }
    const payload = agent.Files.getFlatDirectories()
    this.props.onLoad(payload)
  }

  componentWillUnmount() {
  }

  render() {
    if (!this.props.directories) {
      return (
        <Loading selected={'files'} currentUser={this.props.currentUser}/>
      )
    }
    const name = this.state.name
    const directories = this.props.directories
    const treeData = getTreeFromFlatData({
      flatData: directories.map(node => ({ ...node, title: node.name })),
      getKey: node => node.key, // resolve a node's key
      getParentKey: node => node.parent, // resolve a node's parent's key
      rootKey: null, // The value of the parent key when there is no parent (i.e., at root level)
    })

    const getNodeKey = ({ treeIndex }) => treeIndex;
    const inProgress = this.props.inProgress
    return (
      <div id="main">
        <Nav selected={'dashboard'} />
        <div id="content">
          <Header />
          <div id="content-wrap">
            <div className='box-header'>
              <Link className='header-button' to='/upload'>Upload file</Link>
              <a className='header-button' href='#' onClick={this.openModal}>Create Directory</a>
              <h2>Directories Demo</h2>
            </div>
            <dl className='content-details content-details-alt'>

            </dl>
            <dl className='content-details'>
              <dt>Directories</dt>
              <div style={{ height: 400 }}>
                <SortableTree
                  treeData={treeData}
                  onChange={this.handleTreeOnChange}
                  theme={FileExplorerTheme}
                  maxDepth={5}
                  generateNodeProps={({ node, path, treeIndex }) => ({
                    // buttons: [
                    //   <button onClick={() =>
                    //     this.setState(state => ({
                    //       treeData: addNodeUnderParent({
                    //         treeData: state.treeData,
                    //         parentKey: path[path.length - 1],
                    //         expandParent: true,
                    //         getNodeKey,
                    //         newNode: {
                    //           name: `${Math.floor(Math.random() * 100 + 1)}`,
                    //         },
                    //       }).treeData,
                    //     }))
                    //   }
                    //   >
                    //     Add Child
                    //   </button>,
                    //   <button
                    //     onClick={() => this.setState(state => ({ treeData: removeNodeAtPath({ treeData: state.treeData, path, getNodeKey, }), }))} >
                    //     Remove
                    //   </button>,
                    // ],
                  })}
                />
              </div>
            </dl>
            <hr />
          </div>
        </div>

        <ReactModal isOpen={this.state.showModal} parentSelector={this.getModelParent}>
          <div id="content-clear">
            <div className="focus-wrap">
              <div className='box-header'>
                <h2>Create Directory</h2>
              </div>
              {this.state.password_message}
              <div className="form-item">
                <label>Parent(DropDown)</label>
                <input value={name} onChange={this.updateState('name')} />
              </div>
              <div className="form-item">
                <label>Name</label>
                <input value={name} onChange={this.updateState('name')} />
              </div>
              <ListErrors errors={this.props.errors} />
              <div className="form-item">
                <button className='SubmitButton'
                  disabled={inProgress ? 'disabled' : ''}
                  onClick={this.submitForm(name)}>{inProgress ? 'Updating...' : 'Update'}</button>
                <button className='SubmitButton'
                  disabled={inProgress ? 'disabled' : ''}
                  onClick={this.closeModal}>{'Cancel'}</button>
              </div>
            </div>
          </div>
        </ReactModal>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard)
